/* eslint no-unused-vars:0 */

import axios from "axios";
import {incomePlanAxios} from "@/axios";
import IavAccount from "../models/household/IavAccount";


const SAVINGS_ACCOUNT_SET = 'SAVINGS_ACCOUNT_SET';
const SAVINGS_ACCOUNT_UPDATED = 'SAVINGS_ACCOUNT_UPDATED';
const TOTAL_MANAGED_ACCOUNT_INITIALIZED = 'TOTAL_MANAGED_ACCOUNT_INITIALIZED'
export const accounts = {
    namespaced: true,
    state: {
        accounts: [],
        savingsAccount: {
            id: null,
            value: null,
            specific_year_to_start: null,
            specific_year_to_stop: null,
            start_year_formula: 'specific_year',
            stop_year_formula: 'specific_year',
            value_calculation_method: 0
        },
        totalManagedAccount: null
    },
    getters: {
        accounts: state => state.accounts,
        savingsAccount: state => state.savingsAccount,
        taxQualified() {
            return IavAccount
                .query()
                .withAllRecursive()
                .where((account) => IavAccount.TAX_QUALIFIED_ACCOUNT_TYPES.includes(account.type_of_account_cd))
                .get();
        },
        nonQualifiedAccounts() {
            return IavAccount
                .query()
                .withAllRecursive()
                .where((account) => IavAccount.NON_QUALIFIED_ACCOUNT_TYPES.includes(account.type_of_account_cd))
                .get();
        },
        bankAccounts() {
            return IavAccount
                .query()
                .withAllRecursive()
                .where((account) => IavAccount.BANK_ACCOUNT_TYPES.includes(account.type_of_account_cd))
                .get();
        },
    },
    actions: {
        getTotalManagedAccount({commit, rootGetters}) {
            axios.get('/api/households/' +  rootGetters['auth/user'].household_id + '/total-value', { showLoader: false })
                .then(r => r.data.data)
                .then(response => {
                    commit(TOTAL_MANAGED_ACCOUNT_INITIALIZED, response.total_value)
                });
        },
        loadAccounts ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/household/' + rootGetters['auth/user'].household_id + '/iav-accounts')
                .then(response => {
                    commit('setAccounts', response.data.data.iavAccounts);
                    return response;
                })
        },

        saveAccounts({ commit, getters, rootGetters }) {
            getters.accounts.forEach(account => {
                if (account.id === null) {
                    axios.post('/api/household/' + rootGetters['auth/user'].household_id + '/iav-accounts', account);
                } else {
                    delete account.external_account;
                    axios.put('/api/household/' + rootGetters['auth/user'].household_id + '/iav-accounts/' + account.id, account);
                }
            });
        },

        deleteAccount({ commit, getters, rootGetters }, { account, index }) {
            if (account.id === null) {
                return commit('deleteAccount', { account, index });
            }

            return axios
                .delete('/api/household/' + rootGetters['auth/user'].household_id + '/iav-accounts/' + account.id)
                .then(response => {
                    commit('deleteAccount', { account, index });
                    return response;
                })
        },

        loadSavingsAccount ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/household/' + rootGetters['auth/user'].household_id + '/savings-accounts')
                .then(response => {
                    commit(SAVINGS_ACCOUNT_SET, response.data.data.savingsAccounts[0]);
                    return response;
                })
        },

        updateSavingsAccount({ commit, getters, rootGetters }, {payload}) {
            return incomePlanAxios.put('/api/household/' + rootGetters['auth/user'].household_id + '/savings-accounts/' + payload.id, payload);
        },
    },
    mutations: {
        setAccounts (state, accounts) {
            IavAccount.create({data: accounts});
            // @todo consider removing this state.
            state.accounts = accounts;
        },
        addAccount(state, account) {
            state.accounts.push(account);
        },
        deleteAccount(state, { account, index }) {
            if (account.id === null) {
                state.accounts.splice(index);
            } else {
                state.accounts = state.accounts.filter(i => i.id !== account.id);
            }
        },
        [SAVINGS_ACCOUNT_SET] (state, data) {
            for (let field in state.savingsAccount) {
                state.savingsAccount[field]  = data[field]
            }
        },
        [SAVINGS_ACCOUNT_UPDATED] (state, {payload} ) {
            state.savingsAccount = {...state.savingsAccount, ...payload};
        },
        [TOTAL_MANAGED_ACCOUNT_INITIALIZED] (state, total) {
            state.totalManagedAccount = total;
        }
    }
};
